module.exports = __webpack_public_path__ + "img/payment.21310d4e.svg";